<template>
    <div>
    <TextBanner>
        Seit 2016 umschließt diese Hülle nun den Reaktorblock 4 und den alten Sarkophag. Mehr als 45 Länder und die Europäische Bank für Wiederaufbau/Entwicklung finanzierten das <strong>2,1 Milliarden Euro</strong> teure Projekt.
    </TextBanner>
        
    <InfoBox modalName="HotspotInside">
            
            <template #title>Im neuen Sarkophag</template>
            <template #subline>New Safe Confinement</template>
            <template>
 
                <!--<FullscreenImage v-bind:src="require('../assets/img/dummy-fullscreen.jpg')">-->
                <FullscreenImage v-bind:src="'img/9a_foto_1.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/9a_foto_1_thumb.jpg" alt="">
                        <figcaption>&copy;imago images/tass/sivkov, pyotr</figcaption>

                    </figure>
                </FullscreenImage> 
               Mit speziellen Geräten soll der Rückbau des alten Beton-Sarkophages ermöglicht werden.<p><br><br>


                <!--<FullscreenImage v-bind:src="require('../assets/img/dummy-fullscreen.jpg')">-->
                <FullscreenImage v-bind:src="'img/9a_foto_2.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/9a_foto_2_thumb.jpg" alt="">
                        <figcaption>&copy;imago images/ eastnews</figcaption>
                    </figure>
                </FullscreenImage>

                In diesem Kontrollraum sind vor über 30 Jahre schwerwiegende Fehlentscheidungen getroffen worden.
                Von hier aus wurde Block 4 gesteuert und bedient.<p><br><br>

            

                <!--<FullscreenImage v-bind:src="require('../assets/img/dummy-fullscreen.jpg')">-->
                <FullscreenImage v-bind:src="'img/9a_foto_3.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/9a_foto_3_thumb.jpg" alt="">
                        <figcaption>&copy;imago images/tass/sivkov, pyotr</figcaption>
                    </figure>
                </FullscreenImage>

                Etwa 100 Arbeiter sind in Tschernobyl für den neuen Sarkophag zuständig. Im Kontrollraum werden die Arbeiten überwacht.
                Die starke Strahlenbelastung macht Mensch und Tier zu schaffen.<p><br><br>



                <!--<FullscreenImage v-bind:src="require('../assets/img/dummy-fullscreen.jpg')">-->
                <FullscreenImage v-bind:src="'img/9a_foto_4.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/9a_foto_4_thumb.jpg" alt="">
                        <figcaption>&copy;images/ukrinform</figcaption>
                    </figure>
                </FullscreenImage>

                <p>Die radioaktiven Abfälle werden in solchen Hallen aufbereitet. Hülle und Brennstäbe werden abgebaut, zerteilt, verpackt und
                    schließlich in nahegelegene Endlager gebracht.</p>


            </template>
    </InfoBox>
    
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/11_NSC_innen_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/11_NSC_innen_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('HotspotInside')"></div>	
         
        </Fallback>

    </div>
</template>



<script>
    export default {
        name: 'NSC_Innen',
        babylonState: {
            moveCamera: [-7.4, 1.3, 12, 14 ,0.5,0],    

            hotspot: {
                visible: true,
                infoBox: 'HotspotInside', // Muss zur Infobox oben passen!
                position: [15, 2, -3.5],
                scale: 2,
                //scale: 0,

            },


            Geo_Tschernobyl: {

                children: {

                    BG_Sphere: true,
                    
                    Geo_Beton_Sarkophag: false,
                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Schattenplane_Betonsarkophag_anim: false,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,

                    Geo_Neuer_Sarkophag_anim: false,

                    Geo_Neuer_Sarkophag_endpos_transparent: true,

                    Geo_Schienen_Sarkophag: true,
                    Geo_Schattenplane_NSC_anim: false,
                    Geo_Schattenplane_NSC: true,


                    Geo_GrosserTurm_Gestaenge1: false,
                    Geo_GrosserTurm_Schlot1: false,
                    Geo_GrosserTurm_RoteStreifen1: false,
                    Geo_GrosserTurm_Schattenplane: false,

                    Geo_KleinerTurm_Geruest1: true,
                    Geo_KleinerTurm_Schlot1: true,
                    Geo_KleinerTurm_RoteStreifen1: true,
                    Geo_KleinerTurm_Schattenplane: true, 
                    
          

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            this.$babylonController.setAutoRotateBehaviour(false),
            this.$babylonController.setCameraRadiusLimit (3.5,30),
            this.$babylonController.zoomCamera(1.5)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
